import { useWelfarePortalNavigate } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'

export function SuggestAPartnershipButton() {
  const { t } = useTranslation('catalog')
  const navigate = useWelfarePortalNavigate()

  return (
    <Button
      rounded
      outlined
      icon='pi pi-arrow-right'
      iconPos='right'
      label={t('Catalog.SuggestAPartnership.ButtonLabel')}
      className='mx-5 my-5'
      onClick={() => {
        navigate.goToProposals()
      }}
    ></Button>
  )
}
